import { useDetailedMerchantListQuery } from '~src/pages/merchant/queries';

import { useSiteId } from './useSiteId';

export function useSite() {
  const { merchants } = useDetailedMerchantListQuery();
  const siteId = useSiteId();

  const merchant = merchants.find(m => m.sites.some(s => s.id === siteId));
  const site = merchant?.sites.find(s => s.id === siteId);

  return {
    merchant,
    site,
  };
}
